import React from 'react';

export default class StockChart extends React.PureComponent {

  render() {
    if (!this.props.symbol) {

      return;
    }
    return (
      
      <iframe src={"../__chart.html?symbol=" + this.props.symbol} style={{ "width": "100%", height: 400 }} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/stock-chart.js